var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtpLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "84px",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telegram\u5907\u4EFD 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-13\\u5907\\u4EFD",
    transform: "translate(-245.000000, -338.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telegram\\u5907\\u4EFD-6",
    transform: "translate(245.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#1952DD",
    x: 14,
    y: 14,
    width: 56,
    height: 56,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,29.1768496 C33.7079668,29.1768496 38.3746335,27.6178997 42,24.5 C45.6860954,27.6178997 50.352762,29.1768496 56,29.1768496 C56,34.0761505 56,38.9754514 56,43.8747523 C56,49.1952038 52.9842069,54.055833 48.2171579,56.4185535 L42,59.5 L42,59.5 L35.7828421,56.4185535 C31.0157931,54.055833 28,49.1952038 28,43.8747523 C28,38.9754514 28,34.0761505 28,29.1768496 Z",
    id: "\\u77E9\\u5F62",
    stroke: "#FFFFFF",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(36.750010, 35.015475)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53117327,4.66803662 L8.53117327,3.33401685 C8.53117327,1.46686354 7.08812049,0 5.25000002,0 C3.41286586,0 1.96886701,1.4668431 1.96886701,3.33401685 L1.96886701,4.66803662 L1.31226601,4.66803662 C0.590286722,4.66803662 0,5.26766362 0,5.99997079 L0,12.6680658 C0,13.400373 0.590306864,14 1.31226601,14 L9.18781452,14 C9.90975354,14 10.5,13.400373 10.5,12.6680658 L10.5,5.99997079 C10.5,5.2676636 9.90973342,4.66803662 9.18781452,4.66803662 L8.53117327,4.66803662 Z M7.2852316,3.33401685 L7.2852316,4.66803662 L3.28114307,4.66803662 L3.28114307,3.33401685 L3.21476838,3.33401685 C3.21476838,2.20017263 4.13484513,1.26762856 5.25,1.26762856 C6.36618144,1.26762856 7.2852316,2.20017263 7.2852316,3.33401685 Z M9.18780444,12.6680658 L1.31225593,12.6680658 L1.31225593,5.99997079 L9.18780444,5.99997079 L9.18780444,12.6680658 Z M6.56227608,9.33404898 C6.56227608,8.84508084 6.12486414,8.23194478 5.25004027,7.49464081 C4.37521639,8.23194478 3.93780446,8.84508084 3.93780446,9.33404898 C3.93780446,10.0674399 4.52804085,10.6680074 5.25,10.6680074 C5.97203968,10.6680074 6.56227608,10.0674399 6.56227608,9.33404898 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpLogin);
export default __webpack_public_path__ + "static/media/otp_login.4c2c4ef2dd2d40e6616b55187a73b6c6.svg";
export { ForwardRef as ReactComponent };